import React from "react"
import styled from "styled-components"
import NextImg from "@/common/components/NextImg/index"

import starC from "@/common/assets/image/lucky-bag-2023/decorationsNew/StarS color.svg"
import starW from "@/common/assets/image/lucky-bag-2023/decorationsNew/StarS white.svg"
import starBG from "@/common/assets/image/lucky-bag-2023/decorationsNew/StarBG.svg"
import blobman1 from "@/common/assets/image/lucky-bag-2023/decorationsNew/blob1.svg"
import blobman2 from "@/common/assets/image/lucky-bag-2023/decorationsNew/blob2.svg"
import blobman3 from "@/common/assets/image/lucky-bag-2023/decorationsNew/blobmannoeye.svg"
import blobman4 from "@/common/assets/image/lucky-bag-2023/decorationsNew/blobman3.svg"
import circle from "@/common/assets/image/lucky-bag-2023/decorationsNew/circle.svg"
import Arrow from "@/common/assets/image/lucky-bag-2023/decorationsNew/Arrow.svg"
import { theme } from "./mixin"
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown"

export default function Decoration({ type, animation, time, delay }) {
  function getRandom(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min
  }
  return (
    <Wrapper className={animation} time={time} delay={delay}>
      {type === "blobman1" && <NextImg src={blobman1} />}
      {type === "blobman2" && <NextImg src={blobman2} />}
      {type === "blobman3" && <NextImg src={blobman3} />}
      {type === "blobman4" && <NextImg src={blobman4} />}
      {type === "starW" && <NextImg src={starW} />}
      {type === "starC" && <NextImg src={starC} />}
      {type === "circle" && <NextImg src={circle} />}
      {type === "starBG" && <NextImg src={starBG} />}
      {type === "Arrow" && <NextImg src={Arrow} />}
      {type === "Scircle" && <Circle></Circle>}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  will-change: transform;
  &.updown {
    animation: updown ${({ time }) => time}s infinite
      ease-in-out -${({ delay }) => delay}s;
  }
  &.spin {
    animation: spin ${({ time }) => time}s infinite linear;
  }
  &.twingle {
    animation: twingle ${({ time }) => time}s infinite
      ease-in-out -${({ delay }) => delay}s;
  }
`
const Circle = styled.div`
  width: 100%;
  padding-bottom: 100%;
  border-radius: 50%;
  background: ${theme.orangLinearTop};
`

const ArrowWrapper = styled.div``
const KeyboardDoubleArrowDownIconX = styled(KeyboardDoubleArrowDownIcon)`
  color: #000;
  background-color: #8a2e2e;
`
